import { OrderPaymentType } from '@vista-digital/ocapi-types/v1';
/**
 * Determines whether an [[OrderPayment]] can be removed.
 */
export const isOrderPaymentRemovable = (payment) => {
    switch (payment.type) {
        case OrderPaymentType.GiftCard:
        case OrderPaymentType.MemberBalance:
            return true;
        default:
            return false;
    }
};
export const isOrderMemberBalancePayment = (payment) => payment.type === OrderPaymentType.MemberBalance;
